import { render, staticRenderFns } from "./ResetFeedbackMessage.vue?vue&type=template&id=2b0f0d17&"
import script from "./ResetFeedbackMessage.vue?vue&type=script&lang=js&"
export * from "./ResetFeedbackMessage.vue?vue&type=script&lang=js&"
import style0 from "./ResetFeedbackMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports